import React, { Component } from 'react'

export class Features extends Component {
  render() {
    return (
  <div className='terms'>    
    <h1>Правила проживания в гостевом доме</h1>
      <div class="terms-and-conditions">
        <p>Ознакомьтесь, пожалуйста, с основными правилами проживания в нашем гостевом доме:</p>
        <ul>
          <li><strong>Заезд:</strong> с 14:00, <strong>Выезд:</strong> до 12:00.</li>
          <li>Проживание с детьми приветствуется. Размещение с животными — по согласованию.</li>
          <li>Соблюдайте тишину с 23:00 до 08:00.</li>
          <li>Курение в номерах запрещено.</li>
          <li>Гости несут ответственность за сохранность имущества гостевого дома.</li>
          <li>Принимаем наличные и перевод с карты. Предоплата может потребоваться.</li>
          <li>Бесплатная отмена брони за 7 дней.</li>
        </ul>
        <p>Осуществляя бронирование, вы подтверждаете свое согласие с данными условиями.</p>
      </div>
  </div>
      
    )
  }
}

export default Features